import {Loanslist} from "./loanslist";

export class LoansAuthorized extends Loanslist {
  filter = {authorized: "EQ,true,AND"};

}
